import script from "./issueSettingsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./issueSettingsModal.vue?vue&type=script&setup=true&lang=js"

import "./issueSettingsModal.vue?vue&type=style&index=0&id=caac58fe&lang=css"

const __exports__ = script;

export default __exports__